<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Annual Capital Investment Based on Moving 3-Year Averages</h4>
    <div class="content-block">
        <div class="btndiv">
            <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                (onClick)="export()">
            </dx-button>
        </div>
        <div>
            <dx-responsive-box singleColumnScreen="xs sm md">
                <dxi-row [ratio]="1"></dxi-row>
                <dxi-row [ratio]="1"></dxi-row>
                <dxi-row [ratio]="1"></dxi-row>
                <dxi-row [ratio]="1"></dxi-row>
                <dxi-row [ratio]="1"></dxi-row>
                <dxi-row [ratio]="1"></dxi-row>

                <dxi-col [ratio]="1"></dxi-col>
                <dxi-col [ratio]="1"></dxi-col>
                <dxi-item>
                    <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
                    <h5 style="text-align: center;">{{chartSections[0]}}</h5>
                    <hr />
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="1" [col]="0" [colspan]="1"></dxi-location>
                    <div>
                        <ap-line-graph #GlobalAllBusinessModelChart [(id)]="globalAllBusinessModelChartId" height="400"
                            isLegendVisible="true" valueAxisTitle="Total Capital USD $MM"
                            [dataSource]="asuAndHYCOAllBusinessModelData" title="All Business Models"></ap-line-graph>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="1" [col]="1"></dxi-location>
                    <dx-responsive-box singleColumnScreen="xs sm md">
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-col [ratio]="1"></dxi-col>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="0" [colspan]="1"></dxi-location>
                            <div>
                                <ap-line-graph #GlobalSOEBusinessModelChart [(id)]="globalSOEBusinessModelChartId"
                                    height="200" valueAxisTitle="USD $MM" [dataSource]="asuAndHYCOSOEBusinessModelData"
                                    title="SOE Business Models"></ap-line-graph>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="0" [colspan]="1"></dxi-location>
                            <div>
                                <ap-line-graph #GlobalSOGBusinessModelChart [(id)]="globalSOGBusinessModelChartId"
                                    height="200" valueAxisTitle="USD $MM" [dataSource]="asuAndHYCOSOGBusinessModelData"
                                    title="SOG Business Models"></ap-line-graph>
                            </div>
                        </dxi-item>
                    </dx-responsive-box>
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="2" [col]="0" [colspan]="2"></dxi-location>
                    <hr />
                    <h5 style="text-align: center;">{{chartSections[1]}}</h5>
                    <hr />
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="3" [col]="0" [colspan]="1"></dxi-location>
                    <div>
                        <ap-line-graph #ChinaAllBusinessModelChart [(id)]="chinaAllBusinessModelChartId" height="400"
                            isLegendVisible="true" valueAxisTitle="Total Capital USD $MM"
                            [dataSource]="asuAndHYCOChinaBusinessModelData" title="All Business Models"></ap-line-graph>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="3" [col]="1"></dxi-location>
                    <dx-responsive-box singleColumnScreen="xs sm md">
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-col [ratio]="1"></dxi-col>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="0" [colspan]="1"></dxi-location>
                            <div>
                                <ap-line-graph #ChinaSOEBusinessModelChart [(id)]="chinaSOEBusinessModelChartID"
                                    height="200" valueAxisTitle="USD $MM"
                                    [dataSource]="asuAndHYCOChinaSOEBusinessModelData"
                                    title="SOE Business Models"></ap-line-graph>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="0" [colspan]="1"></dxi-location>
                            <div>
                                <ap-line-graph #ChinaSOGBusinessModelChart [(id)]="chinaSOGBusinessModelChartId"
                                    height="200" valueAxisTitle="USD $MM"
                                    [dataSource]="asuAndHYCOChinaSOGBusinessModelData"
                                    title="SOG Business Models"></ap-line-graph>
                            </div>
                        </dxi-item>
                    </dx-responsive-box>
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="4" [col]="0" [colspan]="2"></dxi-location>
                    <hr />
                    <h5 style="text-align: center;">{{chartSections[2]}}</h5>
                    <hr />
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="5" [col]="0" [colspan]="1"></dxi-location>
                    <div>
                        <ap-line-graph #ROWAllBusinessModelChart [(id)]="rowAllBusinessModelChartId" height="400"
                            isLegendVisible="true" valueAxisTitle="Total Capital USD $MM"
                            [dataSource]="asuAndHYCORowBusinessModelData" title="All Business Models"></ap-line-graph>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="5" [col]="1"></dxi-location>
                    <dx-responsive-box singleColumnScreen="xs sm md">
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-col [ratio]="1"></dxi-col>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="0" [colspan]="1"></dxi-location>
                            <div>
                                <ap-line-graph #ROWSOEBusinessModelChart [(id)]="rowSOEBusinessModelChartId"
                                    height="200" valueAxisTitle="USD $MM"
                                    [dataSource]="asuAndHYCORowSOEBusinessModelData"
                                    title="SOE Business Models"></ap-line-graph>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="0" [colspan]="1"></dxi-location>
                            <div>
                                <ap-line-graph #ROWSOGBusinessModelChart [(id)]="rowSOGBusinessModelChartId"
                                    height="200" valueAxisTitle="USD $MM"
                                    [dataSource]="asuAndHYCORowSOGBusinessModelData"
                                    title="SOG Business Models"></ap-line-graph>
                            </div>
                        </dxi-item>
                    </dx-responsive-box>
                </dxi-item>
            </dx-responsive-box>
        </div>
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>